// src/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getLoggedInUser } from "./utils/auth";

export default function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  const location = useLocation();

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }

  const user = getLoggedInUser();
  const isOperator = user?.role?.toLowerCase() === "operator";

  // If Operator tries to access any route other than /operator-files, redirect
  if (isOperator && location.pathname !== "/operator-files") {
    return <Navigate to="/operator-files" replace />;
  }

  return children;
}
